/** @format */

import React, { useEffect, useState } from "react";
import "./index.scss";
import { useParams, useNavigate } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Grid, IconButton } from "@mui/material";
import FormGenerator from "../../../core/form-generator";
import {
  APPROVED_MODE_OPTIONS,
  ENGINE_PHYSICAL_STATUS,
  ENGINE_TYPE,
  FLOAT_ENGINE_DISPATCHED_MODE,
  FLOAT_ENGINE_STATUS,
  floatEngineActionConfig,
  floatEngineFormConfig,
  TICKET_FORM1,
  TICKET_FORM2,
  TICKET_FORM3,
} from "./config";
import SiFileUpload from "../../../core/file-uploader";
import StaticForm from "../../../components/static-form";
import CustomButtonComponent from "../../../core/custom-button";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import {
  convertToCamelCaseFromUnderScore,
  handleFormValidation,
} from "../../../utils";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import moment from "moment";
import { STATE_LIST } from "../../../utils/state-list";

const FloatEngineDetails = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [files, setFiles] = useState([]);
  const [ticketDetail, setTicketDetails] = useState({});
  const [complaintForm, setComplaintForm] = useState({});
  const [isFloatEngine, setIsFloatEngine] = useState(null);
  const navigate = useNavigate();
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const getPhysicalStatus = (engineNo) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ENGINE_PHYSICAL_STATUS}/${engineNo}`
    )
      .then((res) => {
        if (!res.message) {
          setFormData((prevVal) => ({
            ...prevVal,
            enginePhysicalStatus: res?.batch || "",
          }));
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${id}`,
      null
    )
      .then((response) => {
        if (response.code === 404) {
          toast.error("Invalid ticket");
          return;
        }
        if (response.ticket) {
          const { floatEngine } = response.ticket;
          setTicketDetails(response.ticket);
          if (response?.ticket?.engineNo) {
            getPhysicalStatus(response.ticket.engineNo);
          }
          if (floatEngine?.id) {
            setIsFloatEngine(floatEngine.id);

            setFormData((prevVal) => ({
              ...prevVal,
              ...floatEngine,
              floatEngineDispatchedMode: floatEngine.floatEngineDispatchedMode
                ? FLOAT_ENGINE_DISPATCHED_MODE.find(
                    (ele) => ele.value === floatEngine.floatEngineDispatchedMode
                  )
                : null,
              engineType: floatEngine.engineType
                ? ENGINE_TYPE.find(
                    (ele) => ele.value === floatEngine.engineType
                  )
                : null,
              engineReplacementCost: response?.ticket?.engineReplacementCost,
              status: floatEngine.status
                ? FLOAT_ENGINE_STATUS.find(
                    (ele) => ele.value === floatEngine.status
                  )
                : null,
              state: STATE_LIST?.find(
                (state) => state?.value === floatEngine?.state
              ),
              stoackEnginePhysicalStatus: floatEngine.stoackEnginePhysicalStatus
                ? ENGINE_PHYSICAL_STATUS.find(
                    (ele) =>
                      ele.value === floatEngine.stoackEnginePhysicalStatus
                  )
                : null,
              // engineApprovedMode: floatEngine.engineApprovedMode
              //   ? APPROVED_MODE_OPTIONS.find(
              //       (ele) => ele.value === floatEngine.engineApprovedMode
              //     )
              //   : null,
              focReceiptDate: response.ticket?.foc?.createdAt || null,
              listNumber: response.ticket.listNumber,
              oem: response.ticket.oemOrg?.name,
              invoiceNumber: response.ticket.invoiceNumber || "",
              plant: response.ticket.plant || "",
              engineApprovedMode: convertToCamelCaseFromUnderScore(
                response.ticket.engineReplacementMode
              ),
              invoiceDate: response.ticket.invoiceDate
                ? moment(response.ticket.invoiceDate).format("DD-MM-YYYY")
                : "",
            }));
            setFiles(floatEngine.documents);
          } else {
            setFormData((prevVal) => ({
              ...prevVal,
              focReceiptDate: response.ticket?.foc?.createdAt || null,
              listNumber: response.ticket.listNumber,
              oem: response.ticket.oemOrg?.name,
              invoiceNumber: response.ticket.invoiceNumber || "",
              plant: response.ticket.plant || "",
              engineApprovedMode: convertToCamelCaseFromUnderScore(
                response.ticket.engineReplacementMode
              ),
              invoiceDate: response.ticket.invoiceDate
                ? moment(response.ticket.invoiceDate).format("DD-MM-YYYY")
                : "",
            }));
          }
        }
        if (response.complaintForm) {
          setComplaintForm({
            ...response.complaintForm,
          });
        }
      })
      .catch((err) => console.error(err));
  };
  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      [...floatEngineFormConfig, ...floatEngineActionConfig],
      setErrors,
      formData
    );
    if (isValid) {
      const payload = {
        ...formData,
        engineType: formData.engineType?.value,
        floatEngineDispatchedMode: formData?.floatEngineDispatchedMode?.value,
        engineApprovedMode: formData?.engineApprovedMode?.value,
        status: formData?.status?.value,
        state: formData?.state?.value,
      };
      delete payload.invoiceDate;

      if (files.length > 0) {
        payload.documents = files.map((f) => f.url || f);
      }
      if (formData?.stoackEnginePhysicalStatus) {
        payload["stoackEnginePhysicalStatus"] =
          formData.stoackEnginePhysicalStatus.value;
      }
      if (isFloatEngine) {
        delete payload?.id;
        delete payload?.createdBy;
        delete payload?.createdAt;
        delete payload?.ticketId;
        delete payload?.updatedAt;
        delete payload?.engineReplacementApprovalDate;
        delete payload?.oem;

        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.FLOAT_ENGINE}/${id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Float Engine Details Updated");
              navigate("/admin/float-engine-movement");
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.FLOAT_ENGINE}/${id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Float Engine Details Updated");
              navigate("/admin/float-engine-movement");
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <div className="page-body page-load">
      <div className=" view-detailed-ticket">
        <ArrowBackIcon
          sx={{ cursor: "pointer", marginRight: "20px" }}
          onClick={() => {
            navigate(-1);
          }}
        />
        <div className="border-r">
          <p className="tab-name">Float Engine Movements</p>
          <p className="section-name">Approved engine replacement</p>
        </div>
        <div>
          <p className="tab-name">Ticket ID</p>
          <p className="section-name">{id}</p>
        </div>
      </div>

      <Grid container spacing={3}>
        <Grid item md={9}>
          <div className="form-con" style={{ margin: "0px", width: "100%" }}>
            {/* <FormGenerator
              config={floatEngineFormConfig}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
            /> */}
            <PreviewFormGenerator
              formConfig={floatEngineFormConfig}
              formValues={formData}
            />
            <p className="form-subheader">Actions to be taken</p>
            <FormGenerator
              config={floatEngineActionConfig}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
            />
            {ticketDetail?.engineReplacementStatus !== "ENGINE_DISPATCHED" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SiFileUpload d={null} callBack={callBack} />
                <CustomButtonComponent
                  variant="contained"
                  sx={{ width: "150px", ml: 3 }}
                  size="small"
                  onClick={submitHandler}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            )}

            {files.map((r, index) => {
              return (
                <div key={r.blobName + index}>
                  {r.blobName ? (
                    <span>{r.blobName}</span>
                  ) : (
                    <a href={r} target="_blank">{`Attachment ${index + 1}`}</a>
                  )}

                  <IconButton onClick={() => onDelete(index)}>
                    <CancelOutlinedIcon />
                  </IconButton>
                </div>
              );
            })}
          </div>
        </Grid>
        <Grid item md={3}>
          <div
            className="form-con pr"
            style={{ marginTop: "0px", maxHeight: "max-content" }}
          >
            <p className="form-header">Service Tickets</p>
            <StaticForm config={TICKET_FORM1(ticketDetail, complaintForm)} />
            <p className="form-header">Engine Details</p>
            <StaticForm config={TICKET_FORM2(ticketDetail, complaintForm)} />
            <p className="form-header">Valuation type</p>
            <StaticForm config={TICKET_FORM3(ticketDetail, complaintForm)} />
            {ticketDetail?.foc && (
              <div>
                <p className="form-header">View FOC</p>
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => navigate(`/admin/view-foc/${id}`)}
                >
                  FOC
                </CustomButtonComponent>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default FloatEngineDetails;
